<template>

  <div class="card-background">
      <div class="columns">

      <TournamentMenu :tournament="tournament" />

      <div class="column is-four-fifths-desktop is-four-fifths-tablet is-full-printer">

        <div v-if="tournament">

            <div class="columns">
                <div class="column is-three-fifths-desktop is-half-tablet is-full-printer">
                    <h2 class="has-text-weight-bold has-text-left is-size-3" style="margin-bottom: 30px;">{{ tournament.name }} - Rankings</h2>
                </div>


                <div class="column is-two-fifths-desktop is-half-tablet is-hidden-print">
                    <b-select v-model="mode" class="is-pulled-right">
                        <option value="simple">Simple</option>
                        <option value="full">Full data</option>
                    </b-select>
                </div>
            </div>


            <div class="columns is-multiline">
                <div v-for="event in tournament.events" v-if="getRanking(event) && (mode == 'full' || (!getRanking(event)['m1']))" class="column event-ranking-column is-half-tablet is-half-desktop">
                    <h3 class="has-text-weight-bold has-text-left is-size-5" style="margin-top: 20px;">{{ event.name }}</h3>


                    <table style="margin: 17px 0 30px 0;" class="table is-bordered is-narrow is-striped">
                        <tr>
                            <th>Rank</th>
                            <th>Entry</th>
                        </tr>

                        <tr v-for="pos in 4" v-if="getRanking(event)[pos] && entryIdDirect(getRanking(event)[pos]) != -1">
                            <td style="text-align: right;">{{ pos }}.</td>
                            <td style="padding-right: 20px;"><Entry :entry="fetchEntry(event, getRanking(event)[pos])" :event="event" :tournament="tournament" /></td>
                        </tr>

                        <tr v-for="entry in otherEntries(event)" v-if="mode == 'full'">
                            <td style="text-align: right;">&nbsp;{{((typeof (entry) === 'object') && (entry.wins !== undefined) && (entry.entry !== undefined)) ? entry.wins : ''}}</td>
                            <td style="padding-right: 20px;"><Entry :entry="((typeof (entry) === 'object') && (entry.wins !== undefined) && (entry.entry !== undefined)) ? entry.entry : entry" :event="event" :tournament="tournament" :showMissing="true" /></td>
                        </tr>
                    </table>

                </div>
            </div>
        </div>

        <div v-if="!tournament">
          <b-loading />
        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import Entry from "../components/Entry.vue";
  import TournamentMenu from '../components/TournamentMenu.vue';
  import TournamentDataMixin from '../mixins/TournamentDataMixin.js';


export default {
  mixins: [ TournamentDataMixin ],

  data: () => {
      return {
          mode: 'simple'
      }
  },

  computed: {
    tournaments: function(){ return this.$store.state.tournaments; }
  },

  methods: {
      getRanking: function(event) {

          if (event && this.tournament) {

              let unplayedMatches = 0;
              let allDrawsAreGenerated = event.draws.length > 0;
              event.draws.forEach(draw => {
                  if (draw.stage === 'main-draw' || draw.stage === 'qualification') {
                      unplayedMatches += draw.matches.filter(match => (!match.entry1 || !match.entry2 || !match.result || !match.result.winner)).length;
                  }

                  if (draw.stage !== 'qualification' || !(/^SQ\d+$/.test(draw.name))) {
                      allDrawsAreGenerated = false;
                  }
              });

              let mainDraw = event.draws.filter(d => d.stage === 'main-draw');

              if (unplayedMatches === 0) {

                  if (mainDraw.length === 0 && allDrawsAreGenerated) {
                      let entryWins = {};

                      event.draws.forEach(draw => {
                          draw.matches.forEach(match => {

                              let winningEntry = match.result.winner;
                              let losingEntry = (match.result.winner == match.entry2 ? match.entry1 : match.entry2);

                              entryWins[winningEntry] = (entryWins[winningEntry] || 0) + 1;
                              entryWins[losingEntry] = (entryWins[losingEntry] || 0) - 1;
                          });
                      });


                      let sortedEntries = [];
                      for (let entry in entryWins) {
                          sortedEntries.push({ entry: entry, wins: entryWins[entry] });
                      }

                      sortedEntries.sort((e1, e2) => (e2.wins - e1.wins));


                      let rankIdentifier = 0;
                      let ranking = {};
                      for (let entry of sortedEntries) {
                          rankIdentifier++;
                          ranking['m' + rankIdentifier] = entry;
                      }

                      return ranking;
                  }

                  if (mainDraw.length === 1) {
                      mainDraw = mainDraw[0];

                      if (mainDraw.ranking && mainDraw.ranking[1]) {
                          return mainDraw.ranking;
                      }
                  }

              }
          }

          return undefined;
      },

      otherEntries: function(event) {
          let otherEntries = [];

          let rankedEntries = {};
          let ranking = this.getRanking(event);

          for (let r=1; r <= 4; r++) {
              if (ranking && ranking[r]) {
                  rankedEntries[ranking[r]] = 'true';
              }
          }

          if (ranking && ranking['m1']) {

              //ranking for entries playing entries from different teams
              for (let z=1; z <= 1000000; z++) {

                  let entry = ranking['m' + z];
                  if (!entry){
                      break;
                  }

                  let wins = entry.wins;
                  entry = entry.entry;

                  if (this.entryIdDirect(entry) != -1 && !isNaN(this.entryIdDirect(entry))) {

                      let newId = this.entryIdDirect(entry);
                      otherEntries.push({ wins: (wins >= 0 ? '+' + wins : ('' + wins)), entry: event.entry[newId] });
                  }
              }

              return otherEntries;
          }

          event.draws.forEach(draw => {

              if (draw.entries) {
                  draw.entries.forEach(entry => {

                      if (this.entryIdDirect(entry) != -1) {

                          let newId = this.entryIdDirect(entry);
                          if (!isNaN(newId) && !rankedEntries[newId]) {

                              rankedEntries[newId] = 'true';
                              otherEntries.push(event.entry[newId]);
                          }
                      }
                  });
              }
          });

          return otherEntries;
      },


        entryIdDirect: function(entry) {
            if (!entry) { return null; }

            if (typeof(entry) == 'object') {
                if (entry.id) {
                    return entry.id;
                }

                return 'd' + entry.draw + 'r' + entry.rank;
            }

            return entry;
        },


      fetchEntry(event, entryId) {
          if(typeof(entryId) === 'object') {
              if (entryId.id) {
                  return event.entry[entryId.id];
              } else {
                  let otherDraw = event.draws.filter(d => d.id == entryId.draw)[0];
                  let rank = entryId.rank;

                  return (otherDraw.name + ' #' + rank);
              }
          }

          return event.entry[entryId];
      },
  },

  components: { TournamentMenu, Entry },
  name: 'tournament-rankings'
}
</script>



<style scoped>
    @media print {
        .columns, .columns:not(.is-half-desktop) {
            display: block !important;
            display: block;
        }

        .column.is-half-desktop, .column.is-half-tablet {
            display: inline-block;
        }

        .event-ranking-column.is-half-desktop, .event-ranking-column.is-half-tablet {
            display: inline-block;
            width: 49%;

            page-break-inside: avoid;
        }
    }
</style>
